import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import Layout from "@/components/layout/Layout";
import Seo from "@/components/seo/Seo";
import { authService } from "@/api/services";
import { Button } from "@/components/ui/button";
import { CheckCircle, XCircle } from "@phosphor-icons/react";

export default function VerifyEmail() {
    const [params] = useSearchParams();
    const [status, setStatus] = useState("verifying");

    useEffect(() => {
        const token = params.get("token");
        if (!token) {
            setStatus("failed");
            return;
        }
        authService
            .verifyEmail(token)
            .then(() => setStatus("success"))
            .catch((err) => {
                // eslint-disable-next-line no-console
                console.warn("Verify failed:", err?.message || err);
                setStatus("failed");
            });
    }, [params]);

    return (
        <Layout withFooter={false}>
            <Seo title="Email Verification" path="/verify" noIndex />
            <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-4 text-center">
                <div className="max-w-md">
                    {status === "verifying" && (
                        <p className="font-mono uppercase tracking-widest pulse-sharp text-zinc-400">
                            VERIFYING...
                        </p>
                    )}
                    {status === "success" && (
                        <>
                            <CheckCircle size={56} weight="fill" className="text-primary mx-auto mb-4" />
                            <h1 className="text-3xl font-black uppercase tracking-tighter mb-3">
                                Email verified
                            </h1>
                            <p className="text-zinc-400 mb-6">You can now log in.</p>
                            <Link to="/login">
                                <Button className="rounded-none bg-primary text-primary-foreground hover:bg-[#33FFB0] font-bold uppercase tracking-wider">
                                    Login
                                </Button>
                            </Link>
                        </>
                    )}
                    {status === "failed" && (
                        <>
                            <XCircle size={56} weight="fill" className="text-red-500 mx-auto mb-4" />
                            <h1 className="text-3xl font-black uppercase tracking-tighter mb-3">
                                Invalid link
                            </h1>
                            <p className="text-zinc-400 mb-6">
                                That verification link is invalid or has expired.
                            </p>
                            <Link to="/login">
                                <Button className="rounded-none bg-primary text-primary-foreground hover:bg-[#33FFB0] font-bold uppercase tracking-wider">
                                    Back to login
                                </Button>
                            </Link>
                        </>
                    )}
                </div>
            </div>
        </Layout>
    );
}
